export const EmailFrequency = {
  DAILY: { id: 1, value: 'day' },
  WEEKLY: { id: 2, value: 'week' },
  MONTHLY: { id: 3, value: 'month' },
  BIWEEKLY: { id: 4, value: 'biweekly' },
};
 